import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
//
import ContractsPage from './pages/ContractsPage';
import LoadingDemoPage from './pages/LoadingDemoPage';
// import ClientContractsPage from './pages/ClientContractsPage';
// import ClientDashboardPage from './pages/ClientDashboardPage';
// import DmrDashboard from './pages/DmrDashboard';
// import DmrAnalysis from './pages/DmrAnalysisPage';
// import PracticeInfoPage from './pages/PracticeInfoPage';
// import ClientInvoicePage from './pages/ClientInvoicePage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import HRDashboardPage from './pages/HRDashboardPage';
import LoginPage from './pages/LoginPage';
import NewClientPage from './pages/NewClientPage';
import VeridocPage from './pages/VeridocPage';
import Page404 from './pages/Page404';
import NewClientContractPage from './pages/NewClientContractPage';
import NewQrCodePage from './pages/NewQrCodePage';
import ClientsPage from './pages/ClientsPage';
import AuditTrail from './pages/AuditTrail';
import SupportTicket from './pages/SupportTickets';
import NewSupportTicket from './pages/NewSupportTicket';
import SupportTicketReply from './pages/Reply';
import NewPasswordPage from './pages/NewPasswordPage';
import ShowContractPage from './pages/ShowContractPage';
import SignupPage from './pages/SignupPage';
import BackgroundTasks from './pages/BackgroundTasks';

import EmailTrackingPage from './pages/EmailTracking';
// Productivity Module Pages
import TeamsPage from './pages/TeamsPage';
// HR Module Pages
import HROverviewPage from './pages/hr/HROverviewPage';
import EmployeeManagementPage from './pages/hr/EmployeeManagementPage';
import AttendanceTrackingPage from './pages/hr/AttendanceTrackingPage';
import LeaveManagementPage from './pages/hr/LeaveManagementPage';
import PayrollProcessingPage from './pages/hr/PayrollProcessingPage';
import ExpenseManagementPage from './pages/hr/ExpenseManagementPage';
import IncomeManagementPage from './pages/hr/IncomeManagementPage';
import MoneyAccountManagementPage from './pages/hr/MoneyAccountManagementPage';
import SettingsConfigurationPage from './pages/hr/SettingsConfigurationPage';
import InventoryManagementPage from './pages/hr/InventoryManagementPage';
import InventoryAssignmentManagementPage from './pages/hr/InventoryAssignmentManagementPage';
import ClaimChargeSubmissionUploadPage from './pages/ClaimChargeSubmissionUploadPage';
import EmployeeDashboardPage from './pages/EmployeeDashboardPage';
import { getUserGroups } from './utils';
import StorageManagerPage from './pages/StorageManagerPage';
import EmployeeDashboardHR from './pages/hr/EmployeeDashboardHR';
import FinanceDashboardPage from './pages/reports-and-analytics/FinanceDashboardPage';
import EmailSenderPage from './pages/EmailSenderPage';

// ----------------------------------------------------------------------

export default function Router() {
  const userGroups = getUserGroups();

  // Determine which dashboard to show based on user groups
  let dashboardElement = <AdminDashboardPage />;
  if (userGroups?.includes('associate')) {
    dashboardElement = <EmployeeDashboardPage />;
  } else if (userGroups?.includes('hr')) {
    dashboardElement = <HRDashboardPage />;
  }

  const routes = useRoutes([
    {
      path: '/',
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to="/dashboard" />, index: true },
        { path: 'dashboard', element: dashboardElement },
        { path: 'claim-charge-submissions-upload', element: <ClaimChargeSubmissionUploadPage /> },
        { path: 'clients', element: <ClientsPage /> },
        { path: 'clients/new', element: <NewClientPage /> },
        { path: 'audit-trail', element: <AuditTrail /> },
        { path: 'contracts', element: <ContractsPage /> },
        { path: 'contracts/:id', element: <ShowContractPage /> },
        { path: 'contracts/new', element: <NewClientContractPage /> },
        { path: 'veridoc/new', element: <NewQrCodePage /> },
        { path: 'support-tickets', element: <SupportTicket /> },
        { path: 'background-tasks', element: <BackgroundTasks /> },
        { path: 'support-tickets/new', element: <NewSupportTicket /> },
        { path: 'support-tickets/:id', element: <SupportTicketReply /> },
        { path: 'email-tracking', element: <EmailTrackingPage /> },
        { path: 'email-sender', element: <EmailSenderPage /> },
        { path: 'teams', element: <TeamsPage /> },
        { path: 'loading-demo', element: <LoadingDemoPage /> },
        { path: 'hr', element: <HROverviewPage /> },
        { path: 'hr/employee-dashboard', element: <EmployeeDashboardHR /> },
        { path: 'hr/employees', element: <EmployeeManagementPage /> },
        { path: 'hr/attendance', element: <AttendanceTrackingPage /> },
        { path: 'hr/leave', element: <LeaveManagementPage /> },
        { path: 'hr/payroll', element: <PayrollProcessingPage /> },
        { path: 'hr/expenses', element: <ExpenseManagementPage /> },
        { path: 'hr/income', element: <IncomeManagementPage /> },
        { path: 'hr/accounts', element: <MoneyAccountManagementPage /> },
        { path: 'hr/inventory', element: <InventoryManagementPage /> },
        { path: 'hr/inventory-assignments', element: <InventoryAssignmentManagementPage /> },
        { path: 'hr/settings', element: <SettingsConfigurationPage /> },
        { path: 'storage-manager', element: <StorageManagerPage /> },
        { path: 'finance-dashboard', element: <FinanceDashboardPage /> },

        // { path: 'practice-info', element: <PracticeInfoPage /> },
        // { path: 'client-contracts', element: <ClientContractsPage /> },
        // { path: 'contracts/:id', element: <ShowContractPage /> },
        // { path: 'contracts/new', element: <NewClientContractPage /> },
        // { path: 'client-contracts/new', element: <NewClientContractPage /> },
        // { path: 'support-tickets', element: <SupportTicket /> },
        // { path: 'client-invoices', element: <ClientInvoicePage /> },
        // { path: 'support-tickets/new', element: <NewSupportTicket /> },
        // { path: 'support-tickets/:id', element: <SupportTicketReply /> },
        // { path: 'loading-demo', element: <LoadingDemoPage /> },
      ],
    },
    {
      path: 'login',
      element: <LoginPage />,
    },
    {
      path: 'new-password/:uid/:token',
      element: <NewPasswordPage />,
    },
    {
      path: 'signup',
      element: <SignupPage />,
    },
    {
      path: 'veridoc/:id',
      element: <VeridocPage />,
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/app" />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}
